import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// パフォーマンスを測定する場合は、結果をログに記録する関数を渡すか、分析エンドポイントに送信します。
// 詳細については、次を参照してください：https://bit.ly/CRA-vitals
reportWebVitals();
